import { render, staticRenderFns } from "./LeaseAmendmentsSelector.vue?vue&type=template&id=add06ae8&scoped=true&lang=html&"
import script from "./LeaseAmendmentsSelector.vue?vue&type=script&lang=js&"
export * from "./LeaseAmendmentsSelector.vue?vue&type=script&lang=js&"
import style0 from "./LeaseAmendmentsSelector.vue?vue&type=style&index=0&id=add06ae8&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add06ae8",
  null
  
)

export default component.exports